// Beim Klick auf den Button das Menü umschalten
const menuIcon = document.getElementById('navbar__menu-icon');
const menuIconClose = document.getElementById('navbar__menu-icon-close');
const menu = document.getElementById('menu');

menuIcon.addEventListener('click', () => {
  menu.classList.toggle('visible'),
  menuIcon.classList.toggle('invisible');
  menuIconClose.classList.toggle('visible');
});

menuIconClose.addEventListener('click', () => {
  menu.classList.toggle('visible'),
  menuIcon.classList.toggle('invisible');
  menuIconClose.classList.toggle('visible');
});

// Filter

// Hole alle Filter-Buttons
const filterButtons = document.querySelectorAll('.filter-button');

// Hole alle Referenz-Cases
const referenzenCases = document.querySelectorAll('.referenzen__teaser');

// Füge einen Event-Listener für jeden Filter-Button hinzu
filterButtons.forEach(button => {
  button.addEventListener('click', () => {
    // Hole das Filter-Kriterium (z.B. 'design', 'animation', '3d' oder 'all')
    const filter = button.getAttribute('data-filter');

    // Gehe durch alle Referenzen und filtere sie
    referenzenCases.forEach(caseElement => {
      if (filter === 'all') {
        // Zeige alle Elemente an
        caseElement.classList.remove('hide');
      } else if (caseElement.classList.contains(filter)) {
        // Zeige nur die passenden Elemente an
        caseElement.classList.remove('hide');
      } else {
        // Verstecke alle nicht passenden Elemente
        caseElement.classList.add('hide');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('.menu');

  // Überwacht Änderungen der Klassenzuweisungen auf der .menu-Klasse
  const observer = new MutationObserver(function () {
      // Wenn das Menü die Klasse .visible hat, setzen wir den overflow von body auf 'hidden'
      if (menu.classList.contains('visible')) {
          document.body.style.overflow = 'hidden'; // Scrollen deaktivieren
      } else {
          document.body.style.overflow = 'auto'; // Scrollen aktivieren
      }
  });

  // Beobachte Änderungen an den Klassen des Menu-Elements
  observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
});
